import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

interface ConfirmAddressOverrideDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmAddressOverrideDialog({
  open,
  onConfirm,
  onCancel,
}: Readonly<ConfirmAddressOverrideDialogProps>) {
  return (
    <Dialog open={open} onClose={onCancel} aria-labelledby="address-override-title">
      <DialogTitle id="address-override-title">Save edited address?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This address was auto-filled from a suggested address, but your edits
          no longer match the suggestion. Do you want to save your custom version
          instead?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Keep editing</Button>
        <Button onClick={onConfirm} variant="contained">
          Save custom address
        </Button>
      </DialogActions>
    </Dialog>
  );
}
